import Head from "next/head";
import {useTranslation} from "ni18n";
import React from "react";
import {TermsOfUse} from "src/components/v5/TermsOfUse";

import Layout from "../components/v5/Layout";

const Terms = () => {
  const i18n = useTranslation();

  return (
    <Layout
      pageTitle={i18n.t("Terms of Use | Carbon Health")}
      pageDescription={i18n.t("Carbon Health's Terms of Use.")}
    >
      <Head>
        <style
          dangerouslySetInnerHTML={{
            __html: `
              .tos p,
              .tos h1,
              .tos h2,
              .tos h3,
              .tos h4,
              .tos h5,
              .tos li {
                margin-bottom: 1rem;
                line-height: 1.4;
              }
              .tos a {
                color: #158562;
                text-decoration: underline;
              }
            `,
          }}
        />
      </Head>
      <TermsOfUse />
    </Layout>
  );
};

export default Terms;
